import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDownload, doDelete } from './utils'

// const API_ROOT = 'http://localhost:9005/api'

export const getCloseOfProjectForm = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure`
  return doGet(url)
}

export const updateCloseOfProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure`
  return doPost(url, request)
}

export const getCloseOfProjectCoworkerForm = (projectVersionId) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/refund`
  return doGet(url)
}

export const getCloseOfProjectCoworkerAfterClosedForm = (projectVersionId) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/refund/after-closed`
  return doGet(url)
}

export const updateCloseOfProjectCoworkerAfterClosedForm = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/refund/after-closed`
  return doPost(url, request)
}

export const getCloseOfProjectPaymentQr = (projectVersionId, amount, isInterest = false) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/qrcode-payment/get?amount=${amount}&isInterest=${isInterest}`
  return doGet(url)
}

export const getCalculateTellerPayment = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/calculate-teller-payment`
  return doGet(url)
}

export const updateCloseOfProjectCoworkerForm = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/refund`
  return doPost(url, request)
}

export const getCloseOfProjectFileCoworker = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/attachments`
  return doGet(url)
}

export const saveCloseOfProjectFileCoworker = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/attachments`
  return doPost(url, request)
}

export const updateCloseOfProjectFileNameCoworker = (projectVersionId, fileId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/attachments/${fileId}`
  return doPut(url, request)
}

export const deleteCloseOfProjectFileNameCoworker = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/attachments/${fileId}`
  return doDelete(url)
}

export const downloadCloseOfProjectFileCoworker = (projectVersionId, path) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/attachments/download?path=${path}`
  return doDownload(url)
}

export const getClosureAttachmentNew = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/attachment-new/get`
  return doGet(url)
}

export const saveClosureAttachmentNew = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/attachment-new/upload`
  return doPost(url, request)
}

export const deleteClosureAttachmentNewById = (projectVersionId, id) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/attachment-new/delete/${id}`
  return doDelete(url)
}

export const getCloseOfProjectStaffForm = (projectVersionId) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/request-for-approve`
  return doGet(url)
}

export const updateCloseOfProjectStaffForm = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/request-for-approve`
  return doPost(url, request)
}

export const getCloseOfProjectFileStaff = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/request-for-approve/attachments`
  return doGet(url)
}

export const saveCloseOfProjectFileStaff = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/request-for-approve/attachments`
  return doPost(url, request)
}

export const updateCloseOfProjectFileNameStaff = (projectVersionId, fileId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/request-for-approve/attachments/${fileId}`
  return doPut(url, request)
}

export const deleteCloseOfProjectFileNameStaff = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/request-for-approve/attachments/${fileId}`
  return doDelete(url)
}

export const downloadCloseOfProjectFileStaff = (projectVersionId, path) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/request-for-approve/attachments/download?path=${path}`
  return doDownload(url)
}

export const contractCenterApproveCloseOfProjectForm = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/approve`
  return doGet(url)
}

export const contractCenterApproveCloseOfProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/approve`
  return doPost(url, request)
}

export const secureApproveCloseOfProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/secure-approve`
  return doPost(url, request)
}

export const responseCloseProjectApprove = (referenceID) => {
  const url = `${API_ROOT}/progress/${referenceID}/closure/secure-approve`
  return doGet(url)
}

export const responseTerminateProjectApprove = (referenceID) => {
  // /api/progress/{referenceId}/terminate/secure-approve
  const url = `${API_ROOT}/progress/${referenceID}/terminate/secure-approve`
  return doGet(url)
}

// sub project api

export const getSubprojectCloseOfProjectForm = (projectVersionId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/project-closure`
  return doGet(url)
}

export const updateSubprojectCloseOfProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/project-closure`
  return doPut(url, request)
}

export const approveSubprojectCloseOfProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/project-closure/approve`
  return doPost(url, request)
}

export const getSubprojectCloseOfProjectFile = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/project-closure/attachment/${fileId}`
  return doGet(url)
}

export const downloadSubprojectCloseOfProjectFile = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/project-closure/attachment/${fileId}/download`
  return doDownload(url)
}

export const updateCloseSubProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/subProject/progress/${projectVersionId}/closure`
  return doPost(url, request)
}

export const SaveClosureIPFrom = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/closure/ip`
  return doPost(url, request)
}

export const saveConfirmActualResult = (projectVersionId, request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/proposal/${projectVersionId}/confirm-actual-result`
  return doPost(url, request)
}

export const reviweStepCloseOfProject = (request) => {
  const url = `${API_ROOT}/progress/closure/review-step`
  return doPost(url, request)
}
